




























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Order, Quote } from '@/interfaces/order.interface';
import QuoteForm from '@/components/QuoteForm.vue';
import { namespace } from 'vuex-class';
import { shortDateFormat } from '@/helpers/helpers';
import PermissionsService from '../services/permissions.service';
import { User } from '@/interfaces/user.interface';
import store from '@/store/store';

const ordersModule = namespace('orders');

@Component({
  components: {
    QuoteForm
  }
})
export default class OrderDetailsQuotes extends Vue {
  @Prop({default: []}) order!: Order;
  @ordersModule.Action fetchQuotes: any;
  @ordersModule.Action deleteQuoteWithConfirmation: any;
  @ordersModule.Action selectQuote: any;
  @ordersModule.Action unSelectQuote: any;
  @ordersModule.Action update!: any;

  mounted() {
    this.fetchQuotes({orderUuid: this.order.uuid});
  }

  get quotesHeaders() {
    return [
      {align: 'left', text: 'Forwarder', value: 'forwarderCompanyName'},
      {align: 'left', text: 'ETA', value: 'eta'},
      {align: 'left', text: 'TAT', value: 'tat'},
      {
        align: 'left',
        text: 'Forwarder price',
        value: 'forwarderPrice',
        class: this.canReadForwarderPrice ? '' : 'hidden'
      },
      {align: 'left', text: 'Price', value: 'clientPrice'},
      {align: 'left', text: 'Comment', value: 'comment'},
      {align: 'left', text: '', value: ''},
      {align: 'left', text: '', value: ''}
    ];
  }

  get shortDateFormat(): string {
    return shortDateFormat;
  }

  get quotes(): Quote[] {
    return this.order.quotes || [];
  }

  get isAnyQuoteSelected() {
    return this.order && this.order.quotes && this.order.quotes.find(q => q.selected!);
  }

  get submitQuotesButtonName(): string {
    return this.order.hasQuotesSubmitted ? 'unsubmit' : 'submit';
  }
  get submitQuotesButtonIcon(): string {
    return this.order.hasQuotesSubmitted ? 'block' : 'check';
  }

  del(quote: Quote) {
    this.deleteQuoteWithConfirmation({quote});
  }

  select(quote: Quote) {
    this.selectQuote({quote});
  }

  unselect(quote: Quote) {
    this.unSelectQuote({quote});
  }

  toggleQuotesSubmitted() {
    this.order.hasQuotesSubmitted = !this.order.hasQuotesSubmitted;
    this.update({order: this.order});
  }

  get canSelectQuote(): boolean {
    return PermissionsService.can('quotes', 'update', 'selected');
  }

  get canUpdateQuote(): boolean {
    return PermissionsService.can('quotes', 'update');
  }

  get canDeleteQuote(): boolean {
    return PermissionsService.can('quotes', 'delete');
  }

  get canAddQuote(): boolean {
    return PermissionsService.can('quotes', 'create');
  }

  get canReadForwarderPrice(): boolean {
    return PermissionsService.can('quotes', 'read', 'forwarderPrice');
  }

  get canSubmitQuotes(): boolean {
    const user: User = store.getters['users/currentUser'];
    const createdBy = this.order.createdBy;
    if (user && createdBy) {
      return (PermissionsService.can('unsubmitted_quotes', 'read')||  createdBy.uuid === user.uuid);
    }
    return false;
  }

  get canReadUnsubmittedQuotes(): boolean {
        if (!this.order.hasQuotesSubmitted) {
          return this.canSubmitQuotes;
        }
        return true;
      }
}
